import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { Col, Row, Dropdown } from 'react-bootstrap';

import rank1 from './../images/1st.png';
import rank2 from './../images/2nd.png';
import rank3 from './../images/3rd.png';

const baseURL = (process.env.REACT_APP_BACK_SERVER || '').replace(/\/?$/, '/');

export default function Leaderboard(props) {

    const [show, setShow] = useState(false);
    const [scoreWinner, setScoreWinner] = useState([]);
    const [avgWinner, setAvgWinner] = useState([]);
    // const [duration, setDuration] = useState(3);
    const [duration, setDuration] = useState(2);
    const [activeBoard, setActiveBoard] = useState("score");
    let rowsDisplayed = 0;


    useEffect(() => {

        const fetchLeaderboard = () => {
            let data = {};
            data["code"] = props.groupcode;
            let count3 = 0, count5 = 0, count10 = 0, count15 = 0;
            let avgcount = 0;


            axios.post(baseURL + 'api/getLeaderScoreAll', data)
                .then(res => {
                    if (res.data !== "not found") {

                        // extra codes to create empty rows to fill up the space when there are less than 5 winners for each leaderboard
                        for (var i = 0; i < res.data.length; i++) {
                            // if (res.data[i].duration === 3)
                            if (res.data[i].duration === 2)
                                count3 += 1;
                            if (res.data[i].duration === 5)
                                count5 += 1;
                            if (res.data[i].duration === 10)
                                count10 += 1;
                            if (res.data[i].duration === 15)
                                count15 += 1;
                        }

                        if (count3 < 5) {
                            for (var c3 = 0; c3 < 5 - count3; c3++)
                                // res.data.push({ rank: "", name: "", score: "", duration: 3 });
                                res.data.push({ rank: "", name: "", score: "", duration: 2 });
                        }

                        if (count5 < 5) {
                            for (var c5 = 0; c5 < 5 - count5; c5++)
                                res.data.push({ rank: "", name: "", score: "", duration: 5 });
                        }

                        if (count10 < 5) {
                            for (var c10 = 0; c10 < 5 - count10; c10++)
                                res.data.push({ rank: "", name: "", score: "", duration: 10 });
                        }

                        if (count15 < 5) {
                            for (var c15 = 0; c15 < 5 - count15; c15++)
                                res.data.push({ rank: "", name: "", score: "", duration: 15 });
                        }


                        setScoreWinner(res.data);
                    } else {
                        //no results from database. create empty rows
                        let temp = [];
                        for (var i = 0; i < 5; i++) {
                            // temp.push({ rank: "", name: "", score: "", duration: 3 });
                            temp.push({ rank: "", name: "", score: "", duration: 2 });
                        
                            temp.push({ rank: "", name: "", score: "", duration: 5 });
                       
                            temp.push({ rank: "", name: "", score: "", duration: 10 });
                       
                            temp.push({ rank: "", name: "", score: "", duration: 15 });
                        }
                        setScoreWinner(temp);
                    }

                }).then(res => {
                    axios.post(baseURL + 'api/getLeaderAvgtime', data)
                        .then(res => {
                            if (res.data !== "not found") {
                                for (var i = 0; i < res.data.length; i++) {
                                    avgcount += 1;
                                }

                                if (avgcount < 5) {
                                    for (var a = 0; a < 5 - avgcount; a++)
                                        res.data.push({ rank: "", name: "", score: "", avgtime: "" });
                                }



                                setAvgWinner(res.data);
                            } else {
                                //no results from database. create empty rows
                                let temp = [];
                                for (var i = 0; i < 5; i++) {
                                    temp.push({ rank: "", name: "", score: "", avgtime: "" });
                                }
                                setAvgWinner(temp);
                            }

                        })
                })
        };


        fetchLeaderboard();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps



    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }



    return (
        <div>
            <Button className="topButtons" onClick={handleShow}>
                {props.button}
            </Button>

            <Modal show={show} onHide={handleClose}
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="my-modal"
            >

                <Modal.Body className="text-center">
                    <Row className="align-items-end">
                        <Col><div className="summaryTitle text-center">LEADERBOARD</div>
                        </Col>
                    </Row>
                    <br />
                    <Row className="align-items-center ">
                        <Col>
                            <Dropdown onSelect={function (evt) { setDuration(parseInt(evt)); setActiveBoard("score"); }} >
                                <Dropdown.Toggle variant="light" id="dropdown-basic" className="rankDropDown">
                                    {duration} min
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="rankDropDown">
                                    {/* <Dropdown.Item eventKey='3' className="rankDropDown">3 min</Dropdown.Item> */}
                                    <Dropdown.Item eventKey='2'>2 min</Dropdown.Item>
                                    <Dropdown.Item eventKey="5">5 min</Dropdown.Item>
                                    <Dropdown.Item eventKey="10">10 min</Dropdown.Item>
                                    <Dropdown.Item eventKey="15">15 min</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col>
                            <Button className="rankButton" onClick={function () { setActiveBoard("avgTime"); }}>AVERAGE TIME</Button>

                        </Col>

                    </Row>
                    <Row>
                        <Col className={` ${activeBoard === "score" ? 'ranklineCol' : ''}`}></Col>
                        <Col className={` ${activeBoard === "avgTime" ? 'ranklineCol' : ''}`}></Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>Rank</Col>
                        <Col>Name</Col>
                        <Col>{activeBoard === "score" && <>Score</>}
                            {activeBoard === "avgTime" && <>Average time(S)</>}
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">{activeBoard === "score" &&
                            <> {
                                scoreWinner.map((item, index) => {
                                    return (
                                        <React.Fragment key={index}>

                                            {item.duration === duration && <>
                                                <Row className="rankheight">
                                                    <Col className="rankBigger">
                                                        {item.rank === 1 && <img src={rank1} className="rankicon" />}
                                                        {item.rank === 2 && <img src={rank2} className="rankicon" />}
                                                        {item.rank === 3 && <img src={rank3} className="rankicon" />}
                                                        {(item.rank === 4 || item.rank === 5) && <>{item.rank}</>}
                                                    </Col>
                                                    <Col className="rankBigger">{item.name}</Col>
                                                    <Col className="rankBigger">{item.score}</Col>
                                                </Row>
                                            </>
                                            }


                                        </React.Fragment>
                                    );
                                })
                            }
                            </>
                        }
                            {activeBoard === "avgTime" &&
                                avgWinner.map((item, index) => {
                                    return (
                                        <React.Fragment key={index}>


                                            <Row className="rankheight">
                                                <Col className="rankBigger">
                                                    {item.rank === 1 && <img src={rank1} className="rankicon" />}
                                                    {item.rank === 2 && <img src={rank2} className="rankicon" />}
                                                    {item.rank === 3 && <img src={rank3} className="rankicon" />}
                                                    {(item.rank === 4 || item.rank === 5) && <>{item.rank}</>}
                                                </Col>
                                                <Col className="rankBigger">{item.name}</Col>
                                                <Col className="rankBigger">{item.avgtime}</Col>
                                            </Row>


                                        </React.Fragment>
                                    );
                                })
                            }
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <Button className="yesnoButton" onClick={handleClose}>
                                    CLOSE
                                </Button>
                        </Col>
                    </Row>


                </Modal.Body>

            </Modal>
        </div>
    );


}
